export class Url {
  public static readonly Banks = '/company-bank/banks';
  public static readonly Company = '/company';
  public static readonly CompanyBank = '/company-bank';
  public static readonly CompanyBankCreateConsent = '/company-bank/{companyBankId}/consent/create';
  public static readonly CompanyOnboarding = '/company/{companyId}/onboarding/start';
  public static readonly Payment = '/payment';
  public static readonly PaymentUpdate = '/payment/{authorizationCode}/update';
  public static readonly PaymentValidate = '/payment/{authorizationCode}/validate';
  public static readonly CrmOrganizations = '/crm/organization';
}
